
import { css } from 'lit';
export default css`
:host{
  display:block;
}
  @media print{:host{
    display:block !important;
    --accordion-content-print:auto !important;
    --accordion-content-visibility:visible !important;
    --accordion-content-opacity:1 !important
}

    :host pc-accordion-trigger{
      display:none !important;
    }
  }

.accordion-panel{
  display:flex;
  flex-direction:column;
  width:100%;
  overflow:hidden;
}
`;